module.exports = function () {
    if ($('.careers-header').length) {
        const headerLinksClass = 'careers-header-links';
        const headerLinksOpenClass = 'careers-header-links-open';

        const resizeMenu = function () {
            const lastLink = $('.' + headerLinksClass + ' a').last();
            const height = lastLink.position().top + lastLink.outerHeight() - 16;
            if (ICF.Utils.Breakpoints.IsMobile()) {
                $('.' + headerLinksClass).css('height', height + 'px');
            } else {
                $('.' + headerLinksClass).css('height', '');
            }
        };

        resizeMenu();
        setTimeout(resizeMenu, 100);
        $(window).resize(resizeMenu);

        $('.careers-header-links-open-button').click(function() {
            $('.' + headerLinksClass).toggleClass(headerLinksOpenClass);
            if ($('.' + headerLinksClass).hasClass(headerLinksOpenClass)) {
                $(this).find('img').css('transform', 'rotateZ(180deg)');
            } else {
                $(this).find('img').css('transform', '');
            }
        });
    }
}